import React from 'react';
import Card from '../../common/Card/Card';
import styles from './OverviewSections.module.css';

// Who acts on a step. An owner not listed here gets no tag rather than a wrong one.
const OWNERS = {
  you: { label: 'You', className: 'ownerYou' },
  mentor: { label: 'Mentor', className: 'ownerMentor' },
  portal: { label: 'Official portal', className: 'ownerPortal' },
};

/**
 * How the Application Process Works: the numbered steps, each tagged with who
 * does it. The note above them is the same for every competition, so it lives
 * here and not in the data. Renders nothing when there are no steps.
 */
const ApplicationProcess = ({ steps }) => {
  const ordered = [...(steps || [])]
    .filter((s) => s && s.title)
    .sort((a, b) => (a.step || 0) - (b.step || 0));
  if (!ordered.length) return null;

  return (
    <Card title="How the Application Process Works">
      <div className={styles.processNote}>
        <strong>You write, mentors guide.</strong> You and your team draft every response and create
        your materials. CreatED mentors give structured feedback, request revisions and approve
        sections — they don’t write your application.
      </div>
      <div className={styles.steps}>
        {ordered.map((s, i) => {
          const owner = OWNERS[s.owner];
          return (
            <div key={`${s.title}-${i}`} className={styles.step}>
              <div className={styles.stepTop}>
                <span className={styles.stepNum}>{s.step || i + 1}</span>
                {owner && (
                  <span className={`${styles.ownerTag} ${styles[owner.className]}`}>{owner.label}</span>
                )}
              </div>
              <div className={styles.stepTitle}>{s.title}</div>
              {s.text && <p className={styles.stepText}>{s.text}</p>}
            </div>
          );
        })}
      </div>
    </Card>
  );
};

export default ApplicationProcess;
